import { Component, OnInit } from '@angular/core';
import { RevenueChartComponent } from './revenue/revenue.component';


@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    imports: [RevenueChartComponent]
})
export class DashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    console.log('admin');
  }

}
